module.exports = __webpack_public_path__ + "static/media/time.425d81da.svg";